import { STATUS } from "@/constants/statuses";
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

import PurchasedProductEntity from "../entities/PurchasedProductEntity";

export interface PurchasedProductsState
    extends EntityState<PurchasedProductEntity, number> {
    status: STATUS;
}

@injectable()
@StoreConfig({ name: "purchasedProducts", idKey: "productId" })
class PurchasedProductsStore extends EntityStore<PurchasedProductsState> {
    constructor() {
        super();
    }

    setStatus(status: STATUS) {
        this.update((state) => ({ ...state, status }));
    }

    getStatus() {
        return this.getValue().status;
    }
}

export default PurchasedProductsStore;
